<template>
</template>

<script>
  import Mousetrap from 'mousetrap'
  export default {
    template: '',
    props: ['shortcode', 'modifier'],
    // S'execute lors de l'apparition de l'element
    beforeMount () {
      Mousetrap.bind(this.shortcode, evt => this.$emit('trigger', evt), this.modifier)
    },
    // Se supprime lors de la disparition de l'element
    beforeDestroy () {
      Mousetrap.unbind(this.shortcode, this.modifier)
    }
  }
</script>
  
<style>

</style>
